import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTemplate = () => {
  return (
    <g>
      <path d="m2.089 0 11.824.017c.56 0 1.022.41 1.08.936l.007.114V14.95c0 .541-.425.987-.97 1.044L13.91 16H2.09c-.561 0-1.023-.41-1.083-.936L1 14.95V1.05c0-.54.425-.986.97-1.043L2.09 0zM8 10.5H2.556v4H8v-4zm5.444 0H9.556v4h3.888v-4zM8 5.5H2.556V9H8V5.5zm5.444 0H9.556V9h3.888V5.5zM2.556 1.5v2.498h10.888V1.516L2.556 1.501z" />
    </g>
  );
};

export default withIcon(IconTemplate);
